'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _account = require('./account.service');

var _account2 = _interopRequireDefault(_account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accountModule = _angular2.default.module('account.service', []).service('Account', _account2.default).name;

exports.default = accountModule;


// WEBPACK FOOTER //
// ./client/app/services/accountService/account.js